module.exports = __webpack_public_path__ + "img/icn_disinterested_active.4fc27b73.svg";